
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import HeroPortrait from './components/HeroPortrait';
import Biography from './components/Biography';
import Credentials from './components/Credentials';
import Philosophy from './components/Philosophy';
import Partnerships from './components/Partnerships';

const About = () => {
  return (
    <div className="bg-black min-h-screen">
      <Navigation />
      <main className="pt-20">
        <HeroPortrait />
        <Biography />
        <Credentials />
        <Philosophy />
        <Partnerships />
      </main>
      <Footer />
    </div>
  );
};

export default About;
